module.exports = __webpack_public_path__ + "static/media/case1.e4288e0c.jpg";